module.exports = __webpack_public_path__ + "static/media/productSale.79669c74.svg";